/*
 * Layout Name: Cards CTA
 * Desc:
 */
import Link from "next/link"
import React, { useEffect, useState } from "react"
import Button from "@components/objects/Button/Button"
import arrowRightDark from "@images/icons/arrowRightDark.svg"
import * as styles from "./MoodboardSidebar.module.scss"

const MoodboardSidebar = ({
  imagesSelected,
  isImageSelected,
  handleSubmit,
  clearAllSelectedImages,
  handleImageSelection,
  count,
  imigixParams,
}) => {
  const [showSidebar, setShowSidebar] = useState(false)
  const [isActive, setIsActive] = useState(count > 0)

  useEffect(() => {
    setIsActive(count > 0)
    if (count === 0) {
      setShowSidebar(false)
    }
  }, [count])

  return (
    <>
      <div
        className={`${styles.tab} ${showSidebar ? styles.showSidebar : ""} ${
          isActive ? styles.active : ""
        }`}
        onClick={() => setShowSidebar(true)}
      >
        <span>{count > 0 ? count : 1}</span>
        <h3>Selected</h3>
      </div>
      <div
        className={`${styles.overlay} ${showSidebar ? styles.showSidebar : ""}`}
        onClick={() => setShowSidebar(false)}
      />
      <section
        className={`${styles.sidebar} ${showSidebar ? styles.showSidebar : ""} ${
          isActive ? styles.active : ""
        }`}
      >
        <div className={styles.bar}>
          <h2>
            <span>{count > 0 ? count : 1}</span>
            Selected
          </h2>

          <Button
            className={styles.backButton}
            design="image"
            image={arrowRightDark}
            onClick={() => setShowSidebar(false)}
          />
          <div className={styles.listSection}>
            <div className={styles.list}>
              {imagesSelected && imagesSelected.length
                ? imagesSelected.map((image) => (
                    <div key={image.id} className={styles.image}>
                      <img src={`${image.url}${imigixParams}`} alt="" />
                      <div className={styles.info}>
                        <span>{image.supplier.name}</span>
                      </div>

                      <div className={styles.imageButtons}>
                        <Button
                          design="outline"
                          color="pink"
                          text="View Supplier"
                          link={`/supplier/${image.supplier.slug}`}
                        />
                        <Button
                          design="outline"
                          text="Remove"
                          onClick={() => handleImageSelection(image, true)}
                        />
                      </div>
                    </div>
                  ))
                : null}
            </div>
          </div>
          <div className={styles.buttons}>
            <Button
              className={styles.clearButton}
              design="outline"
              color="dark"
              text="Deselect All"
              onClick={clearAllSelectedImages}
              disabled={!isImageSelected}
            />

            <Button
              className={styles.submitButton}
              text="Next"
              color="dark"
              onClick={handleSubmit}
              disabled={!isImageSelected}
            />
          </div>
        </div>
      </section>
    </>
  )
}

export default MoodboardSidebar
